import React from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { OzonSettingsPage } from './Ozon/OzonSettingsPage'
import { WildberriesSettingsPage } from './Wildberries/WildberriesSettingsPage'
import { YandexMarketSettingsPage } from './YandexMarket/YandexMarketSettingsPage'
import { MoySkladAccountSettingsOldRoute } from './MoySklad/MoySkladAccountSettingsOldRoute'

import { useStore } from '../../hooks/storeHook'
import { useAccountParamsOptional } from '../../hooks/routeHooks'

import { appRoutes } from '../../common/appRoutes'

import { IntegrationType } from '../../server/mpsklad_core/Entity/IntegrationType'

export const SettingsRoute =
  observer(() => {
    const {integration} = useAccountParamsOptional()
    const isMsAccountOldRoute = !!useRouteMatch(appRoutes.MoySkladOld.settings.template)

    const {allowedIntegrations} = useStore()

    if (isMsAccountOldRoute && (!integration || integration === IntegrationType.MoySklad)) {
      return <MoySkladAccountSettingsOldRoute/>
    }

    if (!integration || !allowedIntegrations[integration]) {
      return null
    }

    return (
      <div className="body_wrapper_zero body_wrapper__home">
        {
          integration === IntegrationType.Ozon &&
          <OzonSettingsPage/>
        }

        {
          integration === IntegrationType.Wildberries &&
          <WildberriesSettingsPage/>
        }

        {
          integration === IntegrationType.YandexMarket &&
          <YandexMarketSettingsPage/>
        }
      </div>
    )
  })